import React, { useState } from "react";
import { usePostHog } from "@posthog/react";
import { toast } from "sonner";
import { BarChart3 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { CONSENT_KEY } from "@/posthog";

export const PrivacySettings = () => {
  const posthog = usePostHog();
  const [enabled, setEnabled] = useState(
    typeof window !== "undefined" ? window.localStorage.getItem(CONSENT_KEY) !== "denied" : true
  );

  const toggle = (val) => {
    setEnabled(val);
    window.localStorage.setItem(CONSENT_KEY, val ? "granted" : "denied");
    if (val) posthog?.opt_in_capturing();
    else posthog?.opt_out_capturing();
    toast.success(val ? "Analytics on — thank you for helping improve the app" : "Analytics off");
  };

  return (
    <div className="bg-card border border-border rounded-lg p-5" data-testid="privacy-settings">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className="shrink-0 w-9 h-9 rounded-lg bg-secondary/60 flex items-center justify-center">
            <BarChart3 className="w-5 h-5 text-primary" />
          </span>
          <div>
            <h3 className="font-serif text-xl text-foreground">Usage analytics</h3>
            <p className="text-sm text-muted-foreground mt-1 max-w-md">
              Privacy-friendly analytics (including the searches you run) help us improve results and the wisdom map.
              No name or email is tied to your searches. Turn this off anytime.
            </p>
          </div>
        </div>
        <Switch checked={enabled} onCheckedChange={toggle} data-testid="analytics-toggle" />
      </div>
    </div>
  );
};
